import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
     fetchDimensionsRequest,
     handleGetReportRequestData,
     setIntentCell,
     setListSegmentApplyReload,
     setReloadReportData,
     createBigQueryLog,
} from '../../../../../actions/subscriber';
import { callTokenApi, callTokenApiCancel } from '../../../../../apiCaller';
import {
     API_CLIENT_GET_MAX_STEP_FORM_CATEGORY,
     API_CLIENT_REBUILD_SEGMENT,
     API_CLIENT_REPORTING_EXPLORER,
     API_CLIENT_REPORTING_EXPLORER_PROFILE,
     BQ_JOB_STATUS,
     CHECKLIST_OPTION,
     DEFAULT_DATE_FORMAT,
     EXCLUDE_CHECK_LIST_OPERATOR_OPTION,
     JOB_STATUS,
     OPTIONS_VALUES_FILTER_REPORT,
     PLATFORM_ACCOUNT_STATUSES,
     REPORT_NAMES,
     REPORT_TYPE,
     TYPE_BIGQUERY_JOB_STATUS,
     VARIABLE_OPERATORS_DIMENSION_REPORT,
} from '../../../../../constants';
import { md5, toastError } from '../../../../../utils';
import { getCustomPropertiesReport, handleAssignKeyForDataReport, handleChangeColSort, handleOrderCol, getDefaultFieldReport } from '../../../../../utils/UtilReport';
import { EventExplorerContext } from '../EventExplorer';
import { useDebouncedCallback } from '../../../../../helpers/customHooks';
import dayjs from 'dayjs';
import { SEGMENT_BYTES_BILLED_THRESHOLD } from '../../../../../constants/segment';

const useFetchData = (props) => {
     const {
          reportName,
          filterMetric,
          filterDimensions,
          filterProperties,
          filterEvent,
          setReportData,
          filterEventReport,
          setOffSet,
          scoped,
          reportType,
          conversionName,
          conversionNameMetric,
          externalObjectMetric,
          dateRangeConfig,
          setReportCompare,
          setChangeData,
          recordProfile,
          setMetricsStepForm,
          customDimensionInfo,
          customDimensionIds,
          saleConversionDimensionClick,
          newProperties: propertiesAll,
          newDimensions: dimensionsAll,
          handleGetOption,
          weight,
          utmArray,
          setMaxStepForm,
          eCoItemCategories,
          offSet,
          setAttributeBeforeReload,
          setTempReport,
          reloadTable,
          attributeBeforeReload,
          listSegmentReportApply,
          setListSegmentReportApply,
          setTempScopedReport,
          isWebConversion,
          dimensionEvents,
          listDynamicFields,
          unRelated,
          customObjectSF,
          primaryObject,
          secondaryObject,
          salesConversionName,
          salesConversionDimension,
          setPayloadReportExplorer,
          setPayloadReportFilter,
          intentProperties,
          objectID,
          exportReportTemp,
          setExportReportTemp,
          SFObject,
          setStaticLinkKey,
     } = useContext(EventExplorerContext);
     const reqSegments = !recordProfile ? listSegmentReportApply : [];
     const {
          setIsLoading,
          itemsPerPage,
          activePage,
          sort,
          setShowLongLoading,
          finalActivePage,
          pagination,
          setIsLoadingFetch,
          setReportIsCancel,
          setIsRebuildLoading,
          setReportIsLargeRecords,
     } = props;

     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);
     const { dimensionsDefault, propertiesDefault, metricsDefault } = getDefaultFieldReport({
          reportType,
          reportName,
          scoped,
          weight,
          utmArray,
          properties: propertiesAll,
          dimensions: dimensionsAll,
          objectID,
          eCoItemCategories,
          customExternalObjectReport,
          handleGetOption,
     });
     const metricDynamic = listDynamicFields?.metrics?.length > 0 ? listDynamicFields?.metrics : [];
     const defaultValues = OPTIONS_VALUES_FILTER_REPORT[reportName];

     const { id: accountId, platformAccountStatus, timeZone: activeAccountTimeZone } = useSelector((state) => state.subscriber.activeAccount);
     const dateRangeReports = useSelector((state) => state.subscriber.dateRangeReports);
     const listSegmentReload = useSelector((state) => state.subscriber.listSegmentReload);
     const reloadReportData = useSelector((state) => state.subscriber.reloadReportData);
     const listSegment = useSelector((state) => state.subscriber.listSegment);
     const rebuildSegment = useSelector((state) => state.subscriber.rebuildSegment);
     const segmentJobId = useSelector((state) => state.subscriber.segmentJobId);
     const intentCellState = useSelector((state) => state.subscriber.intentCellState);
     const user = useSelector((state) => state.theme.user);
     const [skipFetch, setSkipFetch] = useState(false);
     const refJobId = useRef('');
     const refInterval = useRef('');
     const timeCallApi = useRef(1500);

     const dependencies = [
          itemsPerPage,
          activePage,
          reloadTable,
          filterEventReport,
          sort.fieldName,
          sort.isDesc,
          dateRangeReports,
          pagination,
          weight,
          listSegmentReload,
          unRelated,
          primaryObject,
     ];

     const [cancelApi, setCancelApi] = useState({});

     const dispatch = useDispatch();

     const useQuery = () => {
          const { search } = useLocation();

          return React.useMemo(() => new URLSearchParams(search), [search]);
     };
     const query = useQuery();
     const dataConversionID = query.get('conversionID');

     const newDateRange = {
          selection: {
               startDate: dateRangeReports?.selection?.startDate?.format(DEFAULT_DATE_FORMAT),
               endDate: dateRangeReports?.selection?.endDate?.format(DEFAULT_DATE_FORMAT),
          },
     };
     if (dateRangeReports.compare) {
          newDateRange.compare = {
               startDate: dateRangeReports?.compare?.startDate?.format(DEFAULT_DATE_FORMAT),
               endDate: dateRangeReports?.compare?.endDate?.format(DEFAULT_DATE_FORMAT),
          };
     }
     if (dateRangeConfig.dateScope) {
          newDateRange.dateScope = dateRangeConfig.dateScope;
     }

     let filterConversionID;
     if (dataConversionID) {
          filterConversionID = [
               {
                    type: 'conversionId',
                    value: dataConversionID,
                    operator: 'eq',
               },
          ];
     }

     const staticLinkObject = {
          reportName,
          reportType,
          scoped: scoped,
          optionsOperator: VARIABLE_OPERATORS_DIMENSION_REPORT,
          dateScope: dateRangeConfig.dateScope,
          dateRangeReports: {
               selection: newDateRange.selection,
               ...(newDateRange.compare ? { compare: newDateRange.compare } : {}),
          },
          customObjectSF,
          SFObject,
          weight: weight,
          clickable: true,
          customDimensionIds: getCustomPropertiesReport(customDimensionInfo, handleOrderCol(dimensionsDefault, filterDimensions)).map((item) => item.id),
          saleConversionDimensionClick: getCustomPropertiesReport(salesConversionDimension, handleOrderCol(dimensionsDefault, filterDimensions)),
          utmArray,
     };

     if (objectID) {
          const externalObject = customExternalObjectReport.find((item) => item?.id === objectID);
          if (externalObject) {
               staticLinkObject.externalObject = externalObject;
          }
     }

     const newDimensions = handleOrderCol(dimensionsDefault, filterDimensions);
     const newMetric = handleChangeColSort([...conversionNameMetric, ...metricsDefault, ...externalObjectMetric, ...metricDynamic], filterMetric).map((i) => i.key);
     const externalObjects = externalObjectMetric.filter((item) => newMetric.includes(item.key));
     const newProperties = handleOrderCol(propertiesDefault, filterProperties);
     const filter = dataConversionID ? filterConversionID : filterEvent;
     const newFilter = filter.map((item) => {
          const newItem = { ...item };
          if (
               item.operator === CHECKLIST_OPTION.value ||
               item.operator === EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value ||
               (defaultValues?.some((el) => el.key === item.type) && [CHECKLIST_OPTION.value, EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value].includes(item.operator))
          ) {
               newItem.value = item.value && Array.isArray(item.value) ? [...item.value].map((el) => el.value) : [];
          }
          delete newItem['optionsOperator'];
          return newItem;
     });
     const fetchDimensions = () => {
          dispatch(fetchDimensionsRequest(accountId));
     };

     useEffect(fetchDimensions, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

     let bodyData = {
          reportName,
          accountId,
          dateRanges: newDateRange,
          limit: itemsPerPage,
          offset: offSet,
          metrics: newMetric,
          properties: newProperties,
          dimensions: newDimensions,
          filter: newFilter,
          sort: sort?.length > 0 ? sort.filter((item) => [...newMetric, ...newProperties, ...newDimensions].includes(item.fieldName)) : sort,
          reportType: reportType,
          scoped: scoped,
          conversionName: conversionName.filter((conversion) => newMetric.some((metric) => metric.includes(conversion.convId))),
          eCommerceName: conversionName.filter((conversion) => newMetric.includes(conversion.value) && conversion.label.includes('Ecommerce')),
          primaryObject,
          secondaryObject,
          salesConversionName,
          salesConversionDimension,
          isCompare: dateRangeConfig.comparePeriod,
          recordProfile: recordProfile || filter?.[0]?.filterRecord || false,
          customProperties: getCustomPropertiesReport(customDimensionInfo, newProperties, newFilter, reportName),
          customDimensions: getCustomPropertiesReport(customDimensionInfo, newDimensions, newFilter, reportName),
          clickCustomDimension:
               saleConversionDimensionClick?.length
                    ? saleConversionDimensionClick
                    : customDimensionInfo.filter((item) => customDimensionIds?.includes(item.id)),
          utmArray,
          weight,
          segments: reqSegments,
          attributeBeforeReload: attributeBeforeReload.scoped !== scoped ? { dimensions: [], properties: [], metrics: [], scoped: '' } : attributeBeforeReload,
          externalObjects,
          unRelated,
          customObjectSF: reportType === REPORT_TYPE.CUSTOM_EXTERNAL ? SFObject : customObjectSF,
          intentProperties,
     };

     if (reportType === REPORT_TYPE.CUSTOM_EXTERNAL) {
          const externalObject = customExternalObjectReport.find((item) => item?.id === objectID);
          bodyData.customExternalObject =
               customExternalObjectReport
                    .filter((item) => item?.externalId === externalObject?.externalId)
                    .map((e) => ({
                         id: e?.id,
                         object: e?.object,
                         connectionId: e?.connectionId,
                         externalId: e?.externalId,
                         characteristicOtherObject: e?.characteristicOtherObject,
                         characteristicIsPerson: e?.characteristicIsPerson,
                         characteristicIsCompany: e?.characteristicIsCompany,
                         characteristicHasRevenue: e?.characteristicHasRevenue,
                         priority: e?.priority,
                    })) || [];
     }
     if (reportName === 'conversionEvents') {
          bodyData.isWebConversion = isWebConversion;
          bodyData.dimensionEvent = dimensionEvents;
     }
     if ([REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
          bodyData.listDynamicFields = listDynamicFields;
     }

     const handleGenerationMetricsStepForm = (number) => {
          const metricsStepForm = [];
          for (let i = 1; i <= number; i++) {
               metricsStepForm.push(
                    { key: `step${i}View`, label: `Step ${i} - View` },
                    { key: `step${i}Start`, label: `Step ${i} - Start` },
                    { key: `step${i}Complete`, label: `Step ${i} - Complete` },
               );
          }
          return metricsStepForm;
     };
     const callApi = ({ API_NAME, apiCancel = false, timeout }) => {
          //  Block calls to the API if there is an unready segment
          if (reqSegments.some((seg) => seg.queryStatus !== BQ_JOB_STATUS.DONE)) return;

          const apiFunction = apiCancel ? callTokenApiCancel : callTokenApi;
          refJobId.current = '';
          apiFunction(API_NAME, 'POST', bodyData).then((response) => {
               if (response?.status === 200) {
                    const {
                         overallRowCount,
                         rows,
                         event,
                         totalsRow,
                         totalRows,
                         message,
                         jobId,
                         temp,
                         tempCompare,
                         tempScoped,
                         tempScopedCompare,
                         isCompare,
                         intentProcessedData,
                    } = response.data;

                    if (message) {
                         if (jobId) {
                              refJobId.current = jobId;
                         }
                         setAttributeBeforeReload({
                              dimensions: bodyData.dimensions,
                              properties: bodyData.properties,
                              metrics: bodyData.metrics,
                              scoped: bodyData.scoped,
                         });
                         setTempScopedReport({ tempScoped, tempScopedCompare });
                         setIsLoadingFetch(true);
                    } else {
                         setReportData({
                              overallRowCount,
                              rows: handleAssignKeyForDataReport({
                                   rows,
                                   dimensions: bodyData.dimensions,
                                   properties: bodyData.properties,
                                   metrics: bodyData.metrics,
                                   listSegmentReportApply,
                              }),
                              res: rows,
                              event,
                              totalsRow,
                         });
                         if (isCompare) {
                              setReportCompare({
                                   rows: handleAssignKeyForDataReport({
                                        rows,
                                        dimensions: bodyData.dimensions,
                                        properties: bodyData.properties,
                                        metrics: bodyData.metrics,
                                        listSegmentReportApply,
                                        isCompare: true,
                                   }),
                                   res: rows,
                                   totalsRow: totalRows,
                              });
                         } else {
                              setReportCompare({ rows: null, res: null, totalsRow: 0 });
                         }

                         setIsLoadingFetch(false);
                         setTimeout(() => {
                              setIsLoading(false);
                         }, 100);
                         setChangeData(false);
                         if (attributeBeforeReload?.dimensions?.length === 0) {
                              setAttributeBeforeReload({
                                   dimensions: bodyData.dimensions,
                                   properties: bodyData.properties,
                                   metrics: bodyData.metrics,
                                   scoped: bodyData.scoped,
                              });
                         }
                         if (temp || tempCompare) {
                              setTempReport({ temp, tempCompare });

                              if (exportReportTemp.isWaiting) {
                                   setExportReportTemp((prev) => ({ ...prev, temp, tempCompare }));
                              }
                         }
                         setTempScopedReport({ tempScoped, tempScopedCompare });

                         // Handle intent processed data for updating cell states
                         if (Array.isArray(intentProcessedData) && intentProcessedData.length > 0) {
                              const newIntentCellState = {};

                              intentProcessedData.forEach((intentCellId) => {
                                   const cellState = { isVisible: true, isSuccess: true };
                                   const existingCell = intentCellState[intentCellId];

                                   if (existingCell?.isLoading) {
                                        cellState.isLoading = true;
                                   }

                                   newIntentCellState[intentCellId] = cellState;
                              });
                              dispatch(setIntentCell(newIntentCellState));
                         }

                         const redisStaticData = md5(JSON.stringify(staticLinkObject));
                         callTokenApi('/client/generate-key-report-link', 'POST', { redisKey: redisStaticData, data: staticLinkObject });
                         setStaticLinkKey(redisStaticData);
                         if (timeout) {
                              clearTimeout(timeout);
                         }

                         setShowLongLoading(false);
                         dispatch(setListSegmentApplyReload(false));
                         timeCallApi.current = 100;

                         if (!!jobId) {
                              createBigQueryLog({ jobId, accountId, status: TYPE_BIGQUERY_JOB_STATUS.CLIENT_DISPLAYED_DATA_AT });
                         }
                    }
               } else {
                    response && toastError(response);
               }
          });
     };

     const callApiFormReport = ({ API_NAME, apiCancel = false, timeout }) => {
          const apiFunction = apiCancel ? callTokenApiCancel : callTokenApi;
          if (cancelApi[API_CLIENT_REPORTING_EXPLORER]) {
               cancelApi[API_CLIENT_REPORTING_EXPLORER].cancel('Request cancelled due to a new request.');
          }
          refJobId.current = '';
          apiFunction(API_NAME, 'POST', bodyData, setCancelApi)
               .then((response) => {
                    if (response?.status === 200) {
                         const dataMetricFormStep = {};

                         dataMetricFormStep.metricsStepForm = handleGenerationMetricsStepForm(response.data.maxStepForm);
                         setMetricsStepForm(dataMetricFormStep.metricsStepForm);
                         dataMetricFormStep.maxStepForm = response.data.maxStepForm;

                         return dataMetricFormStep;
                    } else {
                         response && toastError(response);
                    }
               })
               .then((res) => {
                    if (res) {
                         const valueFilterMetric = filterMetric.map((item) => item.value);

                         bodyData.metrics = [...valueFilterMetric];

                         bodyData.maxStepForm = res.maxStepForm;
                         setMaxStepForm(res.maxStepForm);
                         callTokenApiCancel(API_CLIENT_REPORTING_EXPLORER, 'POST', bodyData, setCancelApi).then((response) => {
                              if (response?.status === 200) {
                                   const { overallRowCount, rows, event, totalsRow, totalRows, message, jobId, temp, tempScoped, tempScopedCompare, isCompare } =
                                        response.data;

                                   if (temp) {
                                        setTempReport({ temp, tempCompare: '' });
                                   }
                                   if (message) {
                                        if (jobId) {
                                             refJobId.current = jobId;
                                        }
                                        setAttributeBeforeReload({
                                             dimensions: bodyData.dimensions,
                                             properties: bodyData.properties,
                                             metrics: bodyData.metrics,
                                             scoped: bodyData.scoped,
                                        });
                                        setTempScopedReport({ tempScoped, tempScopedCompare });
                                        setIsLoadingFetch(true);
                                   } else {
                                        setIsLoadingFetch(false);
                                        setReportData({
                                             overallRowCount,
                                             rows: handleAssignKeyForDataReport({
                                                  rows,
                                                  dimensions: bodyData.dimensions,
                                                  properties: bodyData.properties,
                                                  metrics: bodyData.metrics,
                                                  listSegmentReportApply,
                                             }),
                                             res: rows,
                                             event,
                                             totalsRow,
                                        });
                                        if (isCompare) {
                                             setReportCompare({
                                                  rows: handleAssignKeyForDataReport({
                                                       rows,
                                                       dimensions: bodyData.dimensions,
                                                       properties: bodyData.properties,
                                                       metrics: bodyData.metrics,
                                                       listSegmentReportApply,
                                                       isCompare: true,
                                                  }),
                                                  res: rows,
                                                  totalsRow: totalRows,
                                             });
                                        } else {
                                             setReportCompare({ rows: null, res: rows, totalsRow: 0 });
                                        }

                                        setTimeout(() => {
                                             setIsLoading(false);
                                        }, 100);
                                        setChangeData(false);
                                        setShowLongLoading(false);
                                        if (attributeBeforeReload?.dimensions?.length === 0) {
                                             setAttributeBeforeReload({
                                                  dimensions: bodyData.dimensions,
                                                  properties: bodyData.properties,
                                                  metrics: bodyData.metrics,
                                                  scoped: bodyData.scoped,
                                             });
                                        }
                                        setTempScopedReport({ tempScoped, tempScopedCompare });
                                        const redisStaticData = md5(JSON.stringify(staticLinkObject));
                                        callTokenApi('/client/generate-key-report-link', 'POST', { redisKey: redisStaticData, data: staticLinkObject });
                                        setStaticLinkKey(redisStaticData);
                                        if (timeout) {
                                             clearTimeout(timeout);
                                        }

                                        dispatch(setListSegmentApplyReload(false));
                                        if (!!jobId) {
                                             createBigQueryLog({ jobId, accountId, status: TYPE_BIGQUERY_JOB_STATUS.CLIENT_DISPLAYED_DATA_AT });
                                        }
                                   }
                              } else {
                                   response && toastError(response);
                              }
                         });
                    }
               });
     };

     let timeout;

     const fetchData = (refresh) => {
          if (
               platformAccountStatus === PLATFORM_ACCOUNT_STATUSES.SANDBOX &&
               !localStorage.getItem('llByPassSandbox') &&
               !window.location.search.includes('bypass-sandbox=1')
          ) {
               setReportData({ overallRowCount: 0, rows: [], res: [], totalsRow: 0 });
               setReportCompare({ rows: null, res: null, totalsRow: 0 });
               setTimeout(() => {
                    setIsLoading(false);
               }, 100);
               setIsLoadingFetch(false);
               setChangeData(false);
               setShowLongLoading(false);
               dispatch(setReloadReportData({ ...reloadReportData, tableName: '' }));
               if (timeout) {
                    clearTimeout(timeout);
               }

               if (reloadReportData.status === JOB_STATUS.CANCELED) {
                    setReportIsCancel(true);
               }

               if (reloadReportData.status === BQ_JOB_STATUS.FAILED && reloadReportData?.error.includes('Response too large to return')) {
                    setReportIsLargeRecords(true);
               }
               return;
          }

          if (activePage === 1 && skipFetch) {
               setSkipFetch(false);
               return;
          }
          if (!refresh) {
               setOffSet((finalActivePage - 1) * itemsPerPage);
          }
          if (filterDimensions.length === 0) return;

          setReportIsCancel(false);
          setReportIsLargeRecords(false);
          if (!refresh) {
               // eslint-disable-next-line
               timeout = setTimeout(() => {
                    setChangeData(false);
                    setShowLongLoading(true);
               }, 6000);
          } else if (timeout) {
               clearTimeout(timeout);
          }

          if (recordProfile) {
               callApi({ API_NAME: API_CLIENT_REPORTING_EXPLORER_PROFILE.replace(':reportName', reportName), apiCancel: true, timeout });
          } else if (reportName === REPORT_NAMES.FORM_CATEGORY_REPORT) {
               callApiFormReport({ API_NAME: API_CLIENT_GET_MAX_STEP_FORM_CATEGORY, apiCancel: true, timeout });
          } else {
               callApi({ API_NAME: API_CLIENT_REPORTING_EXPLORER, apiCancel: true, timeout });
          }

          const headerColumn = [...filterDimensions, ...filterProperties, ...filterMetric];
          const { accountId: _, ...respData } = bodyData;

          setPayloadReportExplorer({ ...respData, headerColumn });
     };

     useEffect(() => {
          timeCallApi.current = 1500;
     }, [scoped]);

     const handleRebuildSegment = (segmentIds) => {
          const payload = { accountId, segmentIds };

          setIsRebuildLoading(true);
          refJobId.current = '';
          callTokenApi(API_CLIENT_REBUILD_SEGMENT, 'POST', payload).then((response) => {
               if (response.status === 200) {
                    const { jobId } = response.data;
                    refJobId.current = jobId;
               } else {
                    toastError(response);
               }
          });
     };

     // Stabilize the fetch function
     const handleFetchData = useCallback(() => {
          // Rebuild segments
          const currentTime = dayjs().tz(activeAccountTimeZone);
          const rebuildSegmentFilter = (seg) =>
               seg.totalBytesBilled > SEGMENT_BYTES_BILLED_THRESHOLD && currentTime.diff(dayjs(seg.buildAt).tz(activeAccountTimeZone), 'hour') > 12;
          const rebuildSegmentIds = reqSegments.filter(rebuildSegmentFilter).map((el) => el.id);

          if (rebuildSegmentIds.length > 0) {
               handleRebuildSegment(rebuildSegmentIds);
          } else {
               setIsRebuildLoading(false);
               fetchData();
               if (refInterval.current) clearInterval(refInterval.current);
               refInterval.current = setInterval(checkPusherFallback, 10000);
          }
     }, dependencies); //eslint-disable-line

     // Debounce the fetchData function
     const [debouncedFetchData, cancelDebounce] = useDebouncedCallback(handleFetchData, timeCallApi.current);

     useEffect(() => {
          setIsLoading(true);
          refJobId.current = '';
          if (refInterval.current) clearInterval(refInterval.current);
          debouncedFetchData();

          // Cleanup to cancel the debounce when the component unmounts
          return () => {
               cancelDebounce();
          };
     }, [debouncedFetchData, cancelDebounce]); //eslint-disable-line

     // Refresh api reporting explorer
     useEffect(() => {
          if (reloadReportData?.jobId === refJobId.current) {
               if (reloadReportData && !!reloadReportData.jobId && user?.id === reloadReportData?.userId) {
                    createBigQueryLog({
                         jobId: reloadReportData?.jobId,
                         accountId: reloadReportData?.accountId,
                         status: TYPE_BIGQUERY_JOB_STATUS.CLIENT_RECEIVED_PUSHER_AT,
                    });
               }
               clearInterval(refInterval.current);
               const { status, tableName, comparisonTableName, segmentTables, comparisonSegmentTables, error } = reloadReportData;

               if (
                    status === BQ_JOB_STATUS.DONE &&
                    (platformAccountStatus !== PLATFORM_ACCOUNT_STATUSES.SANDBOX ||
                         localStorage.getItem('llByPassSandbox') ||
                         window.location.search.includes('bypass-sandbox=1'))
               ) {
                    if (reloadReportData.reportName === reportName) {
                         if (tableName) {
                              bodyData.tableName = tableName;
                         }
                         if (comparisonTableName) {
                              bodyData.comparisonTableName = comparisonTableName;
                         }
                         if (segmentTables) {
                              bodyData.segmentTables = segmentTables;
                         }
                         if (comparisonSegmentTables) {
                              bodyData.comparisonSegmentTables = comparisonSegmentTables;
                         }
                         bodyData.jobId = reloadReportData.jobId;
                    }
                    fetchData(true);
               } else {
                    setReportData({ overallRowCount: 0, rows: [], res: [], totalsRow: 0 });
                    setReportCompare({ rows: null, res: null, totalsRow: 0 });
                    setTimeout(() => {
                         setIsLoading(false);
                    }, 100);
                    setChangeData(false);
                    setShowLongLoading(false);
                    setIsLoadingFetch(false);
                    if (timeout) {
                         clearTimeout(timeout);
                    }

                    if (status === BQ_JOB_STATUS.CANCELED) {
                         setReportIsCancel(true);
                    }

                    if (status === BQ_JOB_STATUS.FAILED && error.includes('Response too large to return')) {
                         setReportIsLargeRecords(true);
                    }
               }
          }
     }, [reloadReportData.refreshRequest]); // eslint-disable-line

     const checkPusherFallback = () => {
          if (!refJobId.current) {
               clearInterval(refInterval.current);
               return;
          }
          callTokenApi(`client/check-report-fall-back/${refJobId.current}`, 'GET', null).then((response) => {
               if (response.status === 200 && response.data.data) {
                    dispatch(handleGetReportRequestData(response.data.data));
                    clearInterval(refInterval.current);
               }
          });
     };

     useEffect(() => {
          return () => {
               clearInterval(refInterval.current);
          };
     }, []);

     // Fetch api reporting explorer when rebuild segment completes
     useEffect(() => {
          if (segmentJobId === refJobId.current) {
               setListSegmentReportApply((prevSegments) => {
                    return prevSegments.map((seg) => {
                         const newSegment = Array.isArray(listSegment) && listSegment.find((el) => el.id === seg.id);

                         if (newSegment) {
                              seg.buildAt = newSegment.buildAt;
                              seg.totalBytesBilled = newSegment.totalBytesBilled;
                         }

                         return seg;
                    });
               });

               fetchData();
               setIsRebuildLoading(false);
          }
     }, [rebuildSegment]); // eslint-disable-line

     useEffect(() => {
          setPayloadReportFilter({
               filterDimensions,
               filterMetric,
               filterProperties,
               weight,
          });

          const headerColumn = [...filterDimensions, ...filterProperties, ...filterMetric];
          const { accountId: _, ...respData } = bodyData;

          setPayloadReportExplorer({ ...respData, headerColumn });
     }, [filterDimensions, filterMetric, filterProperties, weight, setPayloadReportFilter, setPayloadReportExplorer]); // eslint-disable-line
};

export default useFetchData;
